import styled from 'styled-components';

import { TextButton } from '@riac/design-system';

export const CatalogHeadContainer = styled.div`
  h3 {
    color: ${(props) => props.theme.black[90]};
  }
`;

export const AuctionTitle = styled.h1`
  color: ${(props) => props.theme.black[100]};
`;

export const AuctionDateTime = styled.div`
  p,
  span {
    font-family: ${(props) => props.theme.serif};
    color: ${(props) => props.theme.black[50]};
  }
`;

export const AuctionSummaryToggle = styled.div`
  margin-top: 1em;
  > ${TextButton} {
    font-size: 1.8rem;
  }
`;
